module.exports = __webpack_public_path__ + "img/slide2_main.63edada5.svg";